@if (loadingState) {
  <dcp-loading-page [loadingText]="loadingScreenText"></dcp-loading-page>
} @else {
  <div class="udex-grid udex-mx-auto udex-pt-16">
    <div class="row">
      <div class="col-6">
        <h3 class="udex-mb-5">Simulation &amp; Testing Page</h3>
      </div>
      @if (user$ | async; as user) {
        <div class="col-6">
          <udex-badge class="float-end" type="Text" design="Neutral" size="Medium"
            >Logged in as: {{ user.name }} ({{ user.email }} | {{ user.scimUserId }})</udex-badge
          >
        </div>
      }
    </div>
    @if (isAuthorized) {
      <dcp-tab-navigation selectedTab="cta-validation"></dcp-tab-navigation>
      <udex-message-strip design="Information" status-type="Icon" hide-close-button class="mb-2 mt-3">
        The CTA determination checks based on business rules whether a call to action can be executed. It is used within
        Configurator to check if the user is eligible to configure the brand and edition.
      </udex-message-strip>
      <p id="technicalNameHelp" class="udex-mb-8 body--s"></p>
      <div class="d-flex udex-mb-8 row">
        <udex-text-field
          label="Technical Name"
          required="required"
          value-state="Standard"
          aria-described-by="technicalNameHelp"
          id="technicalName"
          class="col-lg-3 col-sm-12 mb-sm-2 col-xs-12"
          [value]="technicalName"
          (input)="onInput($event)">
        </udex-text-field>
        <udex-text-field
          label="Material ID / Number"
          required="required"
          value-state="Standard"
          aria-described-by="technicalNameHelp"
          id="materialNumber"
          class="col-lg-3 col-sm-12 mb-sm-2 col-xs-12"
          [value]="materialNumber"
          (input)="onInput($event)">
        </udex-text-field>
        <udex-text-field
          label="S-User ID"
          required="required"
          value-state="Standard"
          aria-described-by="technicalNameHelp"
          id="sUserId"
          class="col-lg-3 col-sm-12 mb-sm-2 col-xs-12"
          [value]="sUserId"
          (input)="onInput($event)">
        </udex-text-field>
        <udex-select-box
          label="Call to Action"
          required="required"
          mode="SingleSelect"
          id="callToAction"
          class="col-lg-3 col-sm-12 mb-sm-2 col-xs-12"
          (selection-change)="onInputCta($any($event))">
          @for (option of ctaOptions; track option) {
            <udex-select-box-item
              [label]="option.label"
              [value]="option.value"
              mode="SingleSelect"
              size="Standard"
              type="None"></udex-select-box-item>
          }
        </udex-select-box>
      </div>

      <div class="d-flex gap-4 udex-mb-8">
        <udex-button
          class="udex-button--wide"
          (click)="getCtaValidation(technicalName, materialNumber, sUserId, callToAction)"
          size="Large"
          design="Primary">
          Validate CTA
        </udex-button>
        <udex-button (click)="onReset()" class="udex-button--wide" size="Large" design="Secondary"> Reset </udex-button>
        <udex-button [disabled]="true" class="udex-button--wide" size="Large" design="Secondary">
          Update Cache
        </udex-button>
      </div>
      <dcp-iframe
        [url]="previewUrl"
        [show]="hasPreviewUrl()"
        (closeEvent)="previewUrl = null"
        title="CTA IFrame"></dcp-iframe>
    }
    <udex-table
      sticky-header
      sticky-column
      heading="Displaying CTAs for {{ technicalName }}"
      no-data-text="No data"
      loading-delay="1000">
      <udex-table-header-row slot="headerRow">
        <udex-table-header-cell>Name</udex-table-header-cell>
        <udex-table-header-cell>Material ID</udex-table-header-cell>
        <udex-table-header-cell>CTA Type</udex-table-header-cell>
        <udex-table-header-cell>Validation</udex-table-header-cell>
        <udex-table-header-cell>Action</udex-table-header-cell>
        <udex-table-header-cell>Target URL</udex-table-header-cell>
      </udex-table-header-row>
      @if (ctaValidationResult$ | async; as productDetermination) {
        @for (entitlement of productDetermination.entitlements; track $index) {
          @for (cta of entitlement.callToActions; track $index) {
            <udex-table-row>
              <udex-table-cell>{{ entitlement.name }}</udex-table-cell>
              <udex-table-cell>{{ entitlement.materialNumber }} </udex-table-cell>
              <udex-table-cell>{{ cta.code }}</udex-table-cell>
              <udex-table-cell>
                @for (error of cta.errors; track $index) {
                  {{ error.code }}<br />
                  {{ error.description }} <br />
                }
              </udex-table-cell>
              <udex-table-cell>
                @if (cta.targetUrl) {
                  <udex-button
                    (click)="togglePreview(convertUrlToCurrentHostname(cta.targetUrl))"
                    [attr.data-cy]="entitlement.materialNumber"
                    size="Large"
                    design="Primary">
                    {{ cta.name }}
                  </udex-button>
                }
              </udex-table-cell>
              <udex-table-cell>
                @if (cta.targetUrl) {
                  <udex-button [cdkCopyToClipboard]="cta.targetUrl" size="Large" design="Primary">
                    Copy URL
                  </udex-button>
                }
              </udex-table-cell>
            </udex-table-row>
          }
        }
      }
    </udex-table>
  </div>
}
